import { useCallback } from "react";
import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import SelectProvider from "components/custom-filters-list/filters/select-provider.component";
import Dialog from "components/dialog";

type BulkUpdateAssigneesModalProps = {
  isOpen: boolean;
  selectedCount: number;
  onClose: () => void;
  onSave: (assignees: number[]) => void;
  isLoading?: boolean;
};

export default function BulkUpdateAssigneesModal({
  isOpen,
  selectedCount,
  onClose,
  onSave,
  isLoading = false
}: BulkUpdateAssigneesModalProps) {
  const { control, handleSubmit, reset } = useForm<{
    assignees: { label: string; value: string }[];
  }>({
    defaultValues: {
      assignees: []
    }
  });

  const onSubmit = useCallback(
    (data: { assignees: { label: string; value: string }[] }) => {
      onSave(data.assignees.map((a) => Number(a.value)));
      reset();
    },
    [onSave, reset]
  );

  const handleClose = useCallback(() => {
    reset();
    onClose();
  }, [reset, onClose]);

  return (
    <Dialog
      title={`Update Assignees for ${selectedCount} task${selectedCount !== 1 ? "s" : ""}`}
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
    >
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} sx={{ p: 2 }}>
          <SelectProvider
            name="assignees"
            control={control}
            label="Assignees"
            multiple
            ignoreRegionsFilter
            ignoreClinicsFilter
          />
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button onClick={handleClose} disabled={isLoading}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" disabled={isLoading}>
              Update
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Dialog>
  );
}
